export default __webpack_public_path__ + "static/media/manali5.2ad72588.webp";